import {Avatar, Button, Image} from 'antd'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {useLocation} from 'react-router-dom'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {SectionTemplate} from "../../Workspace";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {useCourseForm} from "../../../AppLocals/Course/CourseClass/useCourseForm";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {ShopContainerContext} from "./ShopContainer";
import {shop_fetchItems_Api} from "../../../../apis";
import CRUD from "../../../Shared/enums/CRUD";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Shops = ({
                   owner_id,
                   owner_type,
                   filter_actions = {
                       sortBy: 'sort-by',
                       keyword: 'keyword',
                       status: 'shop-status',
                   },
               }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    const [refreshKey, setRefreshKey] = useState()

    const {onChangeSearchParams} = useRouterSearchParam({})
    const {onSelectShopContainerRoute, setCurrentShopId} = useContext(ShopContainerContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)

    const {
        modal,
        handleAction,
        onCancel,
    } = useCourseForm({owner_id, owner_type})

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderShop({
                t,
                onSelectShopContainerRoute,
                renderContextMenu
            }),
            PaginationMeta: renderGridMeta,
            apiInfo: shop_fetchItems_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),

            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })


    return (
        <div className="flex flex-1 flex-col space-y-3">
            <SectionTemplate
                title={t("shop management")}
                description={t("shop management description")}
                actionText={t("create shop")}
                renderActionButton={() => (
                    <Button
                        type="primary"
                        className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"
                        onClick={() => {
                            handleAction(CRUD.CREATE)
                        }}>
                        + {t('create shop')}
                    </Button>
                )}
            />
            {pager_widget}
            {modal}
        </div>
    )
}


const renderShop = ({onSelectShopContainerRoute, t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {

    const {
        avatar, photos = [],
        description, status,
    } = item ?? {}

    return (
        <div
            key={item.id}
            className={classNames(
                "shadow-md rounded-lg hover:scale-xs custom-item-render relative",
            )}>
            <Image
                preview={false}
                src={photos[0]?.path}
                style={{ height: 180 }}
                className="rounded-t-lg rounded-b-0 object-cover"
                wrapperClassName="w-full rounded-t-lg rounded-b-0"
            />
            <div style={{ marginTop: '-1rem' }} className="px-4 flex items-end gap-3">
                <Avatar
                    size={60}
                    src={avatar}
                    style={{ border: '4px solid #fff' }}
                    className="flex flex-center bg-indigo-50 rounded-lg"
                />
                <div className="flex flex-col">
                    <h2
                        onClick={() => {onSelectShopContainerRoute({current_shop_id: item.id})}}
                        className="font-bold text-base text-color-000 hover:text-primary tracking-wide leading-snug cursor-pointer">
                        {item.title}
                    </h2>
                    <div className="flex items-center gap-1 text-xs italic leading-snug">
                        <span className="text-color-400">
                            {`${t("status")}: `}
                        </span>
                        <span className={classNames(
                            "font-medium tracking-wide",
                            status === 1 ? 'text-green-600' : 'text-blue-500'
                        )}>
                            {status === 1 ? t('active') : t('pending')}
                        </span>
                    </div>
                </div>
            </div>
            <div className="mt-2 p-3 py-2 border-t border-color-100 text-color-300 tracking-wider max-lines-3 leading-8">
                {description}
            </div>
            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}


export default Shops
